import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";

import {
  Box,
  Button,
  Container,
  Snackbar,
  Tab,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import moment from "moment";

import { defaultQuizDetails } from "./constant";

// import TrainerService from "./service";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../../header/Header";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import QuizDetails from "./QuizDetails";
import QuizQuestions from "./QuizQuestions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import RouteContext from "../../../../utils/context/RouteContext";
import { roles } from "../../../sidenav/constant";

const getSchema = (formType) => {
  const commonSchema = {
    quizName: yup.string().required(),
    duration: yup.number().required(),
    dueDate: yup.string().required(),
  };
  return yup.object().shape(commonSchema);
};

const QuizForm = () => {
  const [params] = useSearchParams();
  const formType = params.get("formType");
  const {
    state: {
      sessionId,
      data,
      batchId,
      batchName,
      courseName,
      sessionName,
      courseId,
      dataForPrePath,
      batchType,
    },
  } = useLocation();
  const navigate = useNavigate();

  const access = JSON.parse(localStorage.getItem("level"));
  const levelPermission = access?.Batch?.write;
  const { role } = useContext(RouteContext);

  const getFormattedDate = (date) => {
    const formatedDate = moment.utc(date).format("YYYY-MM-DD");
    return formatedDate;
  };

  const [quizDetails, setQuizDetails] = useState(
    formType === "edit"
      ? {
          quizName: data.quizName,
          duration: +data.duration,
          dueDate: getFormattedDate(data.dueDate),
        }
      : defaultQuizDetails
  );

  const [quizId, setQuizId] = useState(formType === "edit" ? data.id : "");

  const [questions, setquestions] = useState([]);
  const [questionValid, setQuestionValid] = useState(false);

  const [editableQuestions, setEditableQuestions] = useState(
    formType === "edit" && data.quizes
  );

  // console.log(quizDetails);
  // console.log(questions);
  // console.log(editableQuestions);
  const [value, setValue] = useState("1");

  const [error, setError] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleDetailsChange = (name, value) => {
    if (name === "duration") {
      const getPositiveValue = (val) => {
        if (!!val) {
          const number = parseInt(val);
          return Math.abs(number);
        }
        return null;
      };
      console.log(getPositiveValue(value), "zxczxczxwqeweweqw");
      setQuizDetails((prev) => ({
        ...prev,
        [name]: getPositiveValue(value),
      }));
    } else {
      setQuizDetails((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuizDetailsReset = () => {
    setQuizDetails(defaultQuizDetails);
  };

  // useEffect(() => {
  //   setQuestionValid(
  //     questions?.[questions.length - 1]?.question != null &&
  //       questions?.[questions?.length - 1]?.options[0].text != "" &&
  //       questions?.[questions?.length - 1]?.correctAnswer != null
  //   );
  // }, [questions]);

  const handleAddQuiz = () => {
    setquestions([
      ...questions,
      {
        question: null,
        options: [
          {
            id: 1,
            text: null,
          },
          {
            id: 2,
            text: null,
          },
          {
            id: 3,
            text: null,
          },
          {
            id: 4,
            text: null,
          },
        ],
        correctAnswer: null,
      },
    ]);
  };

  const handleRemoveClick = (index) => {
    setquestions((prevData) => {
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };
  const handleRemoveEditable = async (index, questionId) => {
    const { data } = await axiosInstance.delete(
      `/quiz/questions/${questionId}`
    );

    data.statusCode === 200 &&
      setEditableQuestions((prevData) => {
        const newData = [...prevData];
        newData.splice(index, 1);
        return newData;
      });
  };
  const handleUpdateQuestion = async (index, question) => {
    const questionId = question.id;
    const payload = {
      question: question.question,
      options: question.options,
      correctAnswer: +question.correctAnswer,
    };
    try {
      const { data } = await axiosInstance.patch(
        `/quiz/question/${questionId}`,
        payload
      );
      console.log(data);
      data.statusCode === 200 && toast.success(data.message);
    } catch (e) {}

    //  data.statusCode === 200 &&
    //     setEditableQuestions((prevData) => {
    //       const newData = [...prevData];
    //       newData.splice(index, 1);
    //       return newData;
    //     });
  };

  console.log(dataForPrePath, sessionId, "sessssssssssss");

  const FinalPublish = () => {
    const isQuestionsValid = questions.every((question) => {
      return (
        question.question !== null && // Check if the question is not empty
        question.correctAnswer !== null && // Check if the correctAnswer is set
        question?.options.filter((op) => op.text !== null).length >= 2
      );
    });

    if (!isQuestionsValid) {
      toast.error("Please fill in all required details of each question");
      return;
    }

    const payload = {
      sessionId: sessionId,
      questions: questions,
    };
    console.log("Final Payload is : ", payload);
    const AddQuiz = async () => {
      try {
        const response = await axiosInstance.post("/quiz/create", payload);
        console.log("Add quiz response : ", response);

        if (response?.data?.success === true) {
          toast.success(response?.data?.message);
          navigate("/batch/session-detail", {
            state: {
              data: dataForPrePath,
              tabValue: "3",
              sessionId: sessionId,
              batchName: batchName,
              batchId: batchId,
              courseId,
              courseName,
            },
          });
        }
      } catch (error) {
        toast.error(error.response?.message || "Something went");
      }
    };
    AddQuiz();
  };
  console.log(dataForPrePath, "dataForPrePath");

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const isQuestionsValid = questions.every((question) => {
      return (
        question.question !== null && // Check if the question is not empty
        question.correctAnswer !== null && // Check if the correctAnswer is set
        question?.options.filter((op) => op.text !== null).length >= 2
      );
    });

    if (!isQuestionsValid) {
      toast.warning("Please fill in all required fields for each question");
      return;
    }

    try {
      const data = await getSchema(formType).validate(
        {
          ...quizDetails,
        },
        { abortEarly: false }
      );
      const createQuizPayload = {
        ...data,
        sessionId: sessionId,
        questions: questions,
      };

      const createQuestionsPayload = {
        questions: questions,
      };
      console.log("payload", createQuizPayload);

      const response =
        formType === "add"
          ? await axiosInstance.post("/quiz/create", createQuizPayload)
          : await axiosInstance.post(
              `/quiz/question/add/${quizId}`,
              createQuestionsPayload
            );
      console.log("Add quiz response : ", response);

      if (response?.data?.success === true) {
        toast.success(response?.data?.message);
        navigate("/batch/session-detail", {
          state: {
            data: dataForPrePath,
            sessionId: sessionId,
            tabValue: "3",
            batchName: batchName,
            batchId: batchId,
            courseId,
            courseName,
          },
        });
      }
    } catch (error) {
      handleError(error.errors[0]);
    }
  };

  console.log(sessionId, dataForPrePath, "dataForPrePath");

  const handleError = (error) => {
    setError(error);
    setTimeout(() => {
      setError("");
    }, 2000);
  };

  const handleBatchoverviewNavigate = ({ courseId, courseName }) => {
    navigate(`/batch/batchesoverview/${courseId}/${courseName}`);
  };

  const handleBatchNavigation = () => {
    {
      batchType === "edit-self-batch"
        ? navigate(
            "/batch/batchesoverview/add-self-batch?formType=edit-self-batch",
            {
              state: {
                courseId,
                courseName,
                batchId,
                batchName,
              },
            }
          )
        : navigate("/batch/batchesoverview/add-batch?formType=edit-batch", {
            state: {
              courseId,
              courseName,
              batchId,
              batchName,
            },
          });
    }
  };

  return (
    <>
      <div className="content-container">
        <Header />
        {/* <Container
      maxWidth="mb"
      style={{
        backgroundColor: "#f7f7f7",
        height: "75vh",
      }}
    > */}
        <div
          className="header-title"
          style={{
            backgroundColor: "white",
            paddingLeft: "4%",
            paddingRight: "4%",
          }}
        >
          <Typography sx={{ marginBottom: "1rem" }}>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() => navigate("/batch")}
            >
              Course List /
            </span>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() =>
                handleBatchoverviewNavigate({ courseName, courseId })
              }
            >
              {courseName} /
            </span>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() => handleBatchNavigation()}
            >
              {batchName} /
            </span>
            <span>{sessionName}</span>
          </Typography>
          <Typography sx={{ fontWeight: "600", color: "#333333" }} variant="h5">
            New Quiz
          </Typography>

          <Box sx={{ width: "100%", typography: "body1", marginTop: "1rem" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  onChange={handleChange}
                  sx={{
                    backgroundColor: "white",
                    paddingLeft: "0.5rem",
                  }}
                  TabIndicatorProps={{
                    style: { backgroundColor: "black" }, // Change the background color to your desired color
                  }}
                  // indicatorColor="primary"
                >
                  <Tab
                    label="Quiz Details"
                    inkBarStyle={{ background: "black" }}
                    value="1"
                    sx={{
                      textTransform: "none",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#000000" : "#B3B3B3",
                      "&.Mui-selected": {
                        color: "#000000",
                        fontWeight: 600,
                      },
                      marginRight: "1rem",
                      fontWeight: 500, // Add a right margin to create a gap between tabs
                      borderBottom: "none", // Remove the bottom line
                    }}
                  />
                  <Tab
                    label="Question"
                    value="2"
                    sx={{
                      textTransform: "none",

                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#000000" : "#B3B3B3",
                      "&.Mui-selected": {
                        color: "#000000",
                        fontWeight: 600,
                        borderBottom: "none",
                      },
                      marginRight: "1rem",
                      fontWeight: 500, // Add a right margin to create a gap between tabs
                      borderBottom: "none", // Remove the bottom line
                    }}
                  />
                  Questions
                </TabList>
              </Box>
              <form onSubmit={handleFormSubmit}>
                <TabPanel value="1" sx={{ padding: "0px !important" }}>
                  {/* <div> */}

                  <QuizDetails
                    quizDetails={quizDetails}
                    handleDetailsChange={handleDetailsChange}
                    formType={formType}
                    handleQuizDetailsReset={handleQuizDetailsReset}
                    setValue={setValue}
                    quizId={quizId}
                    role={role}
                    levelPermission={levelPermission}
                  />

                  {/* </div> */}
                </TabPanel>
                <TabPanel value="2" sx={{ padding: "1rem !important" }}>
                  <QuizQuestions
                    formType={formType}
                    questions={questions}
                    setquestions={setquestions}
                    editableQuestions={editableQuestions}
                    setEditableQuestions={setEditableQuestions}
                    handleAddQuiz={handleAddQuiz}
                    handleRemoveClick={handleRemoveClick}
                    handleRemoveEditable={handleRemoveEditable}
                    handleUpdateQuestion={handleUpdateQuestion}
                    FinalPublish={FinalPublish}
                    role={role}
                    quizId={quizId}
                    levelPermission={levelPermission}
                  />
                  {formType !== "edit" &&
                    (role === "Admin" ||
                      (role === roles.SUB_ADMIN && levelPermission)) && (
                      <div className="save-discard-btn">
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          sx={{ textTransform: "none" }}
                        >
                          Publish
                        </Button>
                      </div>
                    )}
                </TabPanel>
              </form>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};

export default QuizForm;
